import { useState, useEffect } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import MessageBox from '../../MessageBox/MessageBox';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import './InfoSegment.css';

interface IInfoData {
  name: string;
  nominated: string;
  festive: string;
  cities: string;
  trivia: string;
}

export interface IInfoInput {
  name: string;
  nominated: boolean;
  festive: string;
  cities: string;
  trivia: string;
}

interface props {
  data: IInfoInput;
}

const SUBMIT_BUTTON_TITLE = 'ZAPISZ DANE ZESPOŁU';

const InfoSegment = (props: props) => {
  const axiosPrivate = useAxiosPrivate();
  const bandId = sessionStorage.getItem('editedBandId');

  const INFO_URL = bandId ? `/admin/bands/${bandId}` : '/bands';

  const [festiveBox, setFestiveBox] = useState(() => props.data.nominated);
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<IInfoInput>({
    defaultValues: {
      name: '',
      nominated: false,
      festive: '',
      cities: '',
      trivia: '',
    },
  });

  useEffect(() => {
    const { name, nominated, festive, cities, trivia } = props.data;
    setValue('name', name);
    setValue('nominated', nominated);
    setValue('festive', festive);
    setValue('cities', cities);
    setValue('trivia', trivia);
    setFestiveBox(nominated);
    sessionStorage.setItem('bandName', name);
  }, [props]);

  const onSubmit: SubmitHandler<IInfoInput> = async (data) => {
    const { name, nominated, festive, cities, trivia } = data;

    try {
      await axiosPrivate.post(
        INFO_URL,
        JSON.stringify({
          name: name,
          nominated: nominated ? 'tak' : 'nie',
          festive: nominated ? festive : '',
          cities: cities,
          trivia: trivia,
        }),
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      setResult(true);
    } catch (error) {
      setResult(false);
    }

    setOpen(true);
  };

  return (
    <form className="info-container" onSubmit={handleSubmit(onSubmit)}>
      <h2>Dane Zespołu</h2>
      <div className="info-content">
        <Controller
          name="name"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div>
              <label>* Nazwa zespołu</label>
              <TextField {...field} error={errors.name ? true : false} helperText={errors.name ? 'Nazwa zespołu jest wymagana!' : ''} />
            </div>
          )}
        />
        <Controller
          name="nominated"
          control={control}
          render={({ field }) => (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    {...field}
                    checked={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.checked);
                      setFestiveBox(e.target.checked);
                    }}
                    style={{ color: '#ff9100' }}
                  />
                }
                label="Zespół nominowany"
              />
            </div>
          )}
        />
        {festiveBox && (
          <Controller
            name="festive"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <div>
                <label>* Nazwa festiwalu w którym zdobyto nominację</label>
                <TextField {...field} error={errors.festive ? true : false} helperText={errors.festive ? 'Nazwa festiwalu jest wymagana!' : ''} />
              </div>
            )}
          />
        )}
        <Controller
          name="cities"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div>
              <label>
                * Miasto lub miasta z których pochodzą członkowie zespołu
              </label>
              <TextField {...field} error={errors.cities ? true : false} helperText={errors.name ? 'Miasto jest wymagane!' : ''}/>
            </div>
          )}
        />
        <Controller
          name="trivia"
          control={control}
          render={({ field }) => (
            <div style={{ gridArea: '1/2/-1/2' }}>
              <label>Ciekawostki o zespole</label>
              <TextField {...field} multiline rows={festiveBox ? 8 : 5} />
            </div>
          )}
        />
      </div>
      <Button variant="contained" type="submit" size="large">
        {SUBMIT_BUTTON_TITLE}
      </Button>
      <MessageBox open={open} setOpen={setOpen} error={!result} />
    </form>
  );
};

export default InfoSegment;
